import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TextField from 'components/TextField';
import { GreenQuestion } from 'pages/DataLinkage/DataLinkageRequest/style';
import {
  CaptchaImage,
  ContentSectionContentWrapper,
  ContentSectionTextFieldAdjustment,
  ContentSectionTitle,
  ContentSectionWrapper,
  CountDownText,
  RemainTimer,
  RetryButton,
  TextFiledDescription,
} from '../style';

const MallSecondAuthContent = ({
  isGeneralSecondAuthType = true,
  mallSecondAuthObj = {},
  secondAuthDetail = {},
  mallSecondAuthValue = '',
  onChangeTextField = () => {},
  isDisabledInput = true,
  fetchScraping,
  startRemainTime,
  remainingTime,
  setModalData,
  setShowModal,
}) => {
  const navigate = useNavigate();
  const [isCountDownEnd, setIsCountDownEnd] = useState(false);
  const {
    mallName,
    secondAuthQuestion,
    businessDataProviderMallMappingSeq,
    secondAuthDetail: contactInfo,
  } = secondAuthDetail;

  // 시간 형식 노출
  const formatTimer = seconds => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min}:${sec < 10 ? '0' : ''}${sec}`;
  };

  // 재요청 버튼 클릭
  const onClickReRequestBtn = () => {
    fetchScraping({
      successFnc: () => {
        setShowModal(true);
        setModalData({
          contents:
            '2차 인증 문자가 전송되었습니다. 새로 받은 문자 링크를 눌러 인증을 진행해주세요.',
          confirmBtnName: '확인',
          onClickConfirmBtn: () => navigate('/', { replace: true }),
        });
      },
      seq: businessDataProviderMallMappingSeq,
    });
  };

  useEffect(() => {
    // 0:00 노출 후 시간 만료 표시
    if (remainingTime === 0) {
      setTimeout(() => setIsCountDownEnd(true), 300);
    }
  }, [remainingTime]);

  return (
    <ContentSectionWrapper>
      <ContentSectionTitle>
        {isGeneralSecondAuthType === true ? '2차 인증 정보' : '인증 정보'}
      </ContentSectionTitle>
      <ContentSectionContentWrapper>
        <ContentSectionTextFieldAdjustment>
          <TextField
            name="description"
            value="판매몰 개별 연동"
            readOnly={true}
          />
          <TextField name="mallName" value={mallName} readOnly={true} />

          {mallSecondAuthObj?.requirement.includes('CAPTCHA') && (
            <CaptchaImage src={contactInfo} alt="captchaAuth" />
          )}

          {!!secondAuthQuestion &&
            mallSecondAuthObj.requirement === 'CAPTCHA_QUESTION' && (
              <GreenQuestion>{secondAuthQuestion}</GreenQuestion>
            )}

          {!!mallSecondAuthObj.placeholder && (
            <TextField
              name={mallSecondAuthObj.requirement}
              placeholder={mallSecondAuthObj.placeholder}
              value={mallSecondAuthValue}
              onChange={onChangeTextField}
              readOnly={isDisabledInput}
            />
          )}

          {typeof remainingTime === 'number' && (
            <CountDownText>
              {remainingTime < 0 || isCountDownEnd
                ? '인증시간이 만료되었습니다.'
                : '2차인증을 입력해 주세요'}
              {startRemainTime < 0 || isCountDownEnd ? (
                <RetryButton onClick={onClickReRequestBtn}>재요청</RetryButton>
              ) : (
                <RemainTimer>{formatTimer(remainingTime)}</RemainTimer>
              )}
            </CountDownText>
          )}

          {!!mallSecondAuthObj.textDescription && (
            <TextFiledDescription>
              {mallSecondAuthObj.textDescription}
            </TextFiledDescription>
          )}
        </ContentSectionTextFieldAdjustment>
      </ContentSectionContentWrapper>
    </ContentSectionWrapper>
  );
};

export default MallSecondAuthContent;
